var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expansion-panel-header',{attrs:{"hide-actions":_vm.hideActions}},[_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('div',{staticClass:"font-bold overline",style:({
            opacity: _vm.isActive ? 1.0 : 0.4,
          })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)])]),_vm._t("conditional")],2)}
var staticRenderFns = []

export { render, staticRenderFns }